export default "__VITE_PUBLIC_ASSET__5234919e__"